import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#14d9fd",
    },
    secondary: {
      main: "#12b4d1",
    },
    text: {
      primary: "#fff",
      secondary: "#8250CA",
    },
    background: {
      default: "#0c1121",
      secondary: "#8250CA",
      paper: "#161e3b",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: "#14d9fd", 
          color: "#fff", 
          borderRadius: "8px", 
          padding: "8px 16px", 
          "&:hover": {
            backgroundColor: "#12b4d1", 
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-root": {
            backgroundColor: "#161e3b",
            color: "#fff",
            borderRadius: "8px",
            
          },
          "& .MuiInputLabel-root": {
            color: "#fff",
          },
          "& .MuiInputBase-root.Mui-focused": {
            backgroundColor: "#0c1121",
            borderColor: "#14d9fd",
          },
        },
      },
    },
  },
});
